import styled from "styled-components";

export default styled.div`
  display: flex;
  position: relative;
  gap: ${(props) => props.gap};
  justify-content: ${(props) => props.justifyContent || "space-between"};
  align-items: center;
  width: ${(props) => props.width || "100%"};
`;
